import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseCreateReviewRequest
*  Создание отзыва.
*/
export class ShowcaseCreateReviewRequest extends ActiveModel {

  /**
  * rating
  * Оценка 1–5.  */
  @ActiveField()
  rating?: number


/**
  * pros
  * Достоинства.
  */
  @ActiveField()
  pros?: null | string


/**
  * cons
  * Недостатки.
  */
  @ActiveField()
  cons?: null | string


/**
  * text
  * Комментарий.
  */
  @ActiveField()
  text?: null | string


  /**
  * hideAuthorName
  * Не показывать имя автора.  */
  @ActiveField()
  hideAuthorName?: boolean


/**
  * resourceIds
  * Загруженные покупателем фото, в порядке показа.  */
  @ActiveField({
    setter(model: ShowcaseCreateReviewRequest, prop: string, value: Array<string> | undefined, receiver?: ShowcaseCreateReviewRequest ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  resourceIds?: Array<string>


  /**
  * orderItemId
  * Конкретная покупка (из reviewable-items); не указана — подбирается самая свежая.  */
  @ActiveField()
  orderItemId?: null | number
}
